<script setup>
    const props = defineProps({
        items: {
            type: Array,
            required: true,
            default: [],
        },
        title: {
            type: String,
            required: false,
            default: 'Events',
        },
        titleClass: {
            type: String,
            required: false,
            default: 'headline-1',
        },
        showViewAll: {
            type: Boolean,
            required: false,
            default: true,
        },
        showHeader: {
            type: Boolean,
            required: false,
            default: true,
        },
        abridged: {
            type: Boolean,
            required: false,
            default: false,
        },
    });

    const { items, abridged } = toRefs(props);

    const events = computed(() => {
        return abridged?.value === true ? items?.value.slice(0, 3) : items?.value;
    });

    const route = useRoute();

    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/events/';
        else return '/events/';
    });
</script>

<template>
    <section class="live-events" v-if="items && items.length > 0">
        <header class="component-header container hd-container" v-if="showHeader">
            <h2 :class="titleClass">
                <NuxtLink :to="url">{{ title }}</NuxtLink>
            </h2>
            <NuxtLink v-if="showViewAll" :to="url" class="view-all">View All</NuxtLink>
        </header>

        <ul class="container hd-container">
            <CardsEvent v-for="item in events" :key="item.id" :item="item" />
        </ul>
    </section>
</template>

<style lang="scss">
    .live-events {
        padding: 0 0 30px 0;
        
        @media (min-width: $tablet) {
            .container {
                display: grid;
                grid-template-columns: repeat(4, 1fr);
                grid-gap: 15px;
            }

            .component-header {
                display: flex;
            }
        }
    }
</style>
